export default __webpack_public_path__ + "static/media/vector.364c8943.svg";